<template>
    <MainContent title="Crear subscriptor">
        <template v-slot:header>
            <h3 class="card-title mb-3">Crear subscriptor</h3>
        </template>
        <template v-slot:content>
            <FormSubscriptor :subscriptor.sync="subscriptor" :loading.sync="loading" @terminado="crearSubscriptor" />
        </template>
    </MainContent>    
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import FormSubscriptor from '@/components/backend/campana-emails/subscriptores/FormSubscriptor';

    export default {
        data() {
            return {
                subscriptor: {
                    activo: true
                },
                loading: false
            }
        },
        methods: {
            async crearSubscriptor() {
                this.loading = true;
                try {
                    await apiService.createSubscriptor(this.subscriptor);
                    this.$toast.success('Subscriptor creado correctamente');
                    this.$router.push('/admin/emails/subscriptores');
                } catch (error) {
                    console.error('Error al crear el subscriptor:', error);
                } finally {
                    this.loading = false;
                }
            }
        },
        components: {
            MainContent, FormSubscriptor
        }
    }
</script>